
var the_events = $('.eventList');

the_events.each(function() {

        var categoryType = $(this).children('.categoryType');
        var eventCategory = $(this).children('.eventCategory');
        var articleLayout = $(this).children('.articleLayout');
        var eventCount = $(this).children('.eventCount');
        var showFeatureImage = $(this).children('.showFeatureImage');
        var removeGutter = $(this).children('.removeGutter');
        var removeBorder = $(this).children('.removeBorder');
        var showExcerpt = $(this).children('.showExcerpt');
        var eventBtnText = $(this).children('.eventBtnText');

        populateEvents(categoryType.val(), eventCategory.val(), articleLayout.val(), eventCount.val(), showFeatureImage.val(), showExcerpt.val(), eventBtnText.val(), removeGutter.val(), removeBorder.val(), this);

});

function populateEvents(categoryType, eventCategory, articleLayout, eventCount, showFeatureImage, showExcerpt, eventBtnText, removeGutter, removeBorder, eventOutput ) {

    var feedUrl = "https://events.flinders.edu.au";
    var parametersUrl = "?json=get_posts&post_type=ajde_events&orderby=meta_value&meta_key=evcal_srow&order=asc&count=" + eventCount;


    // Is the event category set in the dialogue. 
    if (eventCategory !== "") {
        // Set the URL to include the categoryType slug and category slug. categoryType is the eventon plugin slug (examples: event-type, event-type-2 etc) category slug (examples: feature, student-event, alumni-development, etc)
        feedUrl =  feedUrl + "/" + categoryType + "/" + eventCategory;
    }

    //Set the feed URL
    feedUrl = feedUrl + "/" + parametersUrl;

    $.ajax({
            method: "GET",
            url: feedUrl,
            headers: {}
        }).done(function (data) {
            var events_data = data.posts;
            var events_count = data.count;
            var dataToProvide;
            var eventsTemplate = $('.eventsStandardLayout').first().text();
            var compiledEventsTemplate;

            var start_day_month;
            var end_day_month;

            //apply layout class to main wrapper

            if ( articleLayout == 'overlayLayout') {
                eventsTemplate = $('.eventsOverlayLayout').first().text();        
            }
            else if ( articleLayout == 'listLayout') {
                eventsTemplate = $('.eventsListLayout').first().text();
            }
            
            if ( events_count == "0" ){
                eventsTemplate = $('.noEvents').first().text();
                compiledEventsTemplate = doT.template(eventsTemplate);
                $(eventOutput).append(compiledEventsTemplate());
            }
            else {
                compiledEventsTemplate = doT.template(eventsTemplate);
            }

            for (var i = 0; i < data.count; i++) {
                
                dataToProvide = events_data[i];
                dataToProvide.eventUrl = dataToProvide.url;
                dataToProvide.startDate = new Date(moment.unix(dataToProvide.custom_fields.evcal_srow));
                dataToProvide.endDate = new Date(moment.unix(dataToProvide.custom_fields.evcal_erow));
                dataToProvide.startDate_day = moment.utc(dataToProvide.startDate).format('DD');
                dataToProvide.endDate_day = moment.utc(dataToProvide.endDate).format('DD');
                dataToProvide.startDate_month = moment.utc(dataToProvide.startDate).format('MMM');
                dataToProvide.endDate_month = moment.utc(dataToProvide.endDate).format('MMM');
                dataToProvide.startDate_time = moment.utc(dataToProvide.startDate).format('h:mm a');
                dataToProvide.endDate_time = moment.utc(dataToProvide.endDate).format('h:mm a');

                // MAkes sure there is valid location data
                try {
                dataToProvide.location = dataToProvide.taxonomy_event_location[0].title;
                }
                catch(err) {
                  dataToProvide.location = "";
                }

                dataToProvide.title = dataToProvide.title;
                dataToProvide.event_excerpt = dataToProvide.excerpt;

                start_day_month = dataToProvide.startDate_day + dataToProvide.startDate_month;
                end_day_month = dataToProvide.endDate_day + dataToProvide.endDate_month;

                // Is there alternative text for the event detail button
                if (eventBtnText == "") {
                    dataToProvide.eventBtnDetails = "View details";
                }
                else {
                    dataToProvide.eventBtnDetails = eventBtnText;
                }

                start_day_month = dataToProvide.startDate_day + dataToProvide.startDate_month;
                end_day_month = dataToProvide.endDate_day + dataToProvide.endDate_month;

                //If the event does not go over multiple dates then hide the end date.
                if (start_day_month == end_day_month) {
                    dataToProvide.multipleDateHidden = "hide_date";
                }

                // Does the events have a feature image and is the show feature dialogue checked?
                if (dataToProvide.hasOwnProperty("thumbnail_images") && showFeatureImage == 'showFeature') {
                   dataToProvide.bgImage = dataToProvide.thumbnail_images.full.url;
                   dataToProvide.overlay ='events_overlay';
                   dataToProvide.showFeature ='events_image';

                   if (articleLayout == "standardLayout" || articleLayout == "listLayout") {
                        dataToProvide.buttonStyle = 'events-read-more-btn-navy';
                   }
                   else {
                        dataToProvide.buttonStyle = 'events-read-more-btn-white';
                   }
                   
                }
                else {
                    //if standard layout does not have a thumbnail but has feature image set to showfeature.
                    if ( articleLayout == 'standardLayout' && showFeatureImage == 'showFeature') {
                    dataToProvide.showFeature ='events_image';
                    dataToProvide.bgImage = "https://www.flinders.edu.au/content/dam/images/aem-components/events-component/events-component-feature-image-fallback-02.jpg";
                    dataToProvide.buttonStyle = 'events-read-more-btn-navy';
                    }
                    else {
                    dataToProvide.bgImage = '#';
                    dataToProvide.overlay = 'events_overlay_no_bg_image';
                    dataToProvide.buttonStyle = 'events-read-more-btn-navy';
                    }                 
                }

                //is remove gutter checked
                if (removeGutter !== 'no-gutter') {
                    dataToProvide.articleRowSpacing = 'rowSpacing';
                }

                // is remove border checked
                if (removeBorder == "no-border") {
                    dataToProvide.articleBorder = '';
                }
                else {
                    dataToProvide.articleBorder = 'events-border';
                }

                // Is show excertp checked?
                if (showExcerpt == 'showExcerpt') {
                    dataToProvide.show_excerpt ='events_show_excerpt';
                }
                else {
                    dataToProvide.show_excerpt ='events_hide_excerpt';                   
                }
                
                // Default column layout for eventCount = 3, 6 or 9 or all(10000).
                dataToProvide.column_layout = 'col-md-12 col-lg-4';

                // Column layout if article laout is list.
                if (articleLayout == 'listLayout'){
                    dataToProvide.column_layout = 'col-sm-12';
                }
                // Column layout based on the number of articles selected to display.
                else if (eventCount == '1') {
                    dataToProvide.column_layout = 'col-lg-12';
                }
                else if (eventCount == '2'){
                    dataToProvide.column_layout = 'col-sm-12 col-md-6';
                }
                else if (eventCount == '4' || eventCount == '8' ){
                    dataToProvide.column_layout = 'col-sm-12 col-md-6 col-lg-3';
                }

                $(eventOutput).append(compiledEventsTemplate(dataToProvide));

            }


            //Ellipsis calls - force content to a number of lines
            $('.events_excerpts_line, .events_overlay_excerpts_line, .events_title h3').ellipsis({
              lines: 2,
              responsive: true
            });
            //End Ellipsis

        });

}





